import React, { useEffect, useState } from 'react';
import '../styles/door.css';

export default function DoorTransition({ isVisible, onComplete }) {
  const [phase, setPhase] = useState('closed'); // closed | opening | done

  useEffect(() => {
    if (!isVisible) { setPhase('closed'); return; }
    const t1 = setTimeout(() => setPhase('opening'), 150);
    const t2 = setTimeout(() => { setPhase('done'); onComplete?.(); }, 3400);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [isVisible, onComplete]);

  if (!isVisible || phase === 'done') return null;

  return (
    <div className={`door2-overlay ${phase}`} aria-hidden="true">
      {/* Divine light — emanates from the gap as doors open */}
      <div className="door2-glow" />
      <div className="door2-glow-beam" />

      {/* Left panel — no text, ornamental only */}
      <div className="door2-panel door2-left">
        <div className="door2-inner">
          <div className="door2-gold-edge door2-gold-right" />
          <div className="door2-ornament">
            <div className="door2-orn-hline" />
            <div className="door2-orn-diamond" />
            <div className="door2-orn-hline" />
          </div>
          <div className="door2-handle door2-handle-r" />
        </div>
      </div>

      {/* Right panel — mirror of left */}
      <div className="door2-panel door2-right">
        <div className="door2-inner">
          <div className="door2-gold-edge door2-gold-left" />
          <div className="door2-ornament">
            <div className="door2-orn-hline" />
            <div className="door2-orn-diamond" />
            <div className="door2-orn-hline" />
          </div>
          <div className="door2-handle door2-handle-l" />
        </div>
      </div>
    </div>
  );
}
